import { Component, HostListener, inject } from "@angular/core";
import { AppComponent } from "../app.component";
import { UltimaComponent } from "./ultima.component";
import { UserHelperService } from "@main/users/user-helper.service";
import { BrandingService } from "../branding/branding.service";

@Component({
    selector: "ultima-topbar",
    templateUrl: "./ultima-topbar.component.html",
    styleUrls: ["./ultima-topbar.component.scss"]
})
export class UltimaTopbarComponent {
    protected readonly brandingService = inject(BrandingService);

    showInitials: boolean = false;
    isSmallScreen = false;

    constructor(public app: AppComponent, public ultimaMain: UltimaComponent, private userService: UserHelperService) {
        this.updateIsSmallScreen();
    }

    onRuntimeEditorTopbarItemClick(event, rutimeEditorTopbarItem) {
        if (this.app.runtimeEditorToggle()) {
            this.ultimaMain.onTopbarItemClick(event, rutimeEditorTopbarItem);
        } else {
            event.preventDefault();
        }
    }

    get showTopbarItems() {
        return !this.userService.isGenericPatient;
    }

    get isPatient() {
        return this.userService.isPatient;
    }

    @HostListener("window:resize")
    private updateIsSmallScreen() {
        this.isSmallScreen = window.innerWidth >= 576;
    }
}
